import React from 'react';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { ErrorPage } from '../../components';

const Forbidden = () => {
  const { t } = useTranslation();
  return (
    <ErrorPage>
      <h1>{t('pages.403.title')}</h1>
      <p>{t('pages.403.body')}</p>
      <Button
        primary
        href={t('pages.403.primary_button.url')}
        className="icon-after icon-arrow icon-variant-1"
      >
        {t('pages.403.primary_button.link')}
      </Button>
    </ErrorPage>
  );
};

export default Forbidden;
